import { Spin } from "antd"
import '../components/LoadingGLobal/style.scss'
interface Prop {
  checkLoading?: boolean
}
const LoadingSpin: React.FC<Prop> = ({
  checkLoading
}) => {

  return (
    <Spin size="large" className="custom-loading" spinning={checkLoading} />
  )
}
export default LoadingSpin
